<template>
  <p class="status status--validation-failed" v-if="error !== ''">
    {{ error }}
  </p>
</template>
<script>
export default {
  props: {
    error: [String, Error],
  },
};
</script>
<style scoped>
.status {
  margin: 0 0 1rem 0;
}
</style>
